<template>
  <div>
    <inline-field-actions :schema="schema"></inline-field-actions>
    <div v-html="schema.staticText"></div>
  </div>
</template>

<script>
  import { abstractField } from 'vue-form-generator';

  export default {
    mixins: [abstractField],
  };
</script>
